<script lang="ts" setup>
  type Props = {
    row?: boolean
    small?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    row: false,
    small: false,
  })
</script>
<template>
  <div
    class="lc-content-fit"
    :class="{ row: props.row, small: props.small }"
  >
    <div class="content">
      <slot />
    </div>
  </div>
</template>
<style scoped>
.lc-content-fit {
  display: flex;
  max-width: 100%;
  flex: 1 0 auto;
  flex-direction: column;
  align-items: center;
  padding: 0 1.5em;

  .content {
    position: relative;
    display: flex;
    width: 100%;
    max-width: 1600px;
    flex: 1 0 auto;
    flex-direction: column;
  }

  &.row {
    .content {
      flex-direction: row;
    }
  }

  &.small {
    .content {
      max-width: 1400px;
    }
  }

  @media screen and (width >= 1024px) {
    padding: 0 2.5em;
  }
}
</style>
